import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./config";

/**
 * Deve envolver a árvore após AuthProvider para permitir hooks que leem locale do usuário.
 */
export function I18nProvider({ children }) {
  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
}
